import { apiConfig } from "@/config/apiConfig";
import { createRpcRequest, handleRpcResponse, logRpcCall, logRpcError } from "../utils/rpc.helpers";

export const makeRpcCall = async <P, T>(
  method: string,
  params?: P,
  headers: Record<string, string> = {},
  init?: Omit<RequestInit, 'method' | 'headers' | 'body'>,
  id: string = "1"
): Promise<T> => {
  const requestBody = createRpcRequest(method, params, id);
  
  try {
    const response = await fetch(apiConfig.baseRpcUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...headers,
      },
      body: JSON.stringify(requestBody),
      ...init,
    });

    logRpcCall(method, params, response.status);
    return await handleRpcResponse<T>(response);
    
  } catch (error) {
    logRpcError(method, params, error);
    throw error;
  }
};
